'use strict';

import { ISeason } from '../../interfaces';

/**
 * Filters options to show in select filter list
 */
export class Filter {
  id: number;
  name: string;

  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}

export class AdminBasketUtil {

  getTotalExtras(basket) {
    let total = 0;
    for (let extra of basket.extras) {
      total += extra.totalPrice;
    }
    return Number((total).toFixed(2));
  }

  getTotalPayment(basket) {
    let totalPayment = 0;
    for (let pay of basket.payments) {
      totalPayment += pay.amount;
    }
    return Number((totalPayment).toFixed(2));
  }

  /**
   * Parsing basket's extras to model format to show on view
   */
  parseExtraToModelView(basket, season: ISeason) {
    let extrasParsing = [];

    _.each(basket.extras, extra => {
      let candidate:any = _.find(season.availableExtras, e => {
         return e._id == extra.extra;
      });
      extrasParsing.push({
        extra: candidate,
        selected: true,
        quantity: extra.quantity,
        totalPrice: extra.totalPrice
      });
    });

    basket.extras = extrasParsing;
  }

  /**
   * Parsing basket's extras from model to data to save on database
   * @param basket 
   */
  parseExtraToData(basket) {
    let extrasParsing = [];

    _.each(basket.extras, extra => {
      extrasParsing.push({
        extra: extra.extra._id,
        quantity: extra.quantity,
        totalPrice: extra.totalPrice
      });
    });
  }

  parseToFloatTwoDecimal(num) {
    if (num !== null) {
      return Number(num).toFixed(2);
    }
    return null;
  }
}


// WEBPACK FOOTER //
// ./client/app/admin/adminBaskets/adminBasketUtil.ts